<template>
  <v-container>
    <v-row justify="center" class="mt-0">
      <v-col cols="12" xl="11" lg="11" md="11" class="pt-0">
        <v-card
          elevation="0"
          class="rounded-lg d-flex"
          height="690"
          color="transparent"
        >
          <v-card-text
            class="
              overflow-y-auto
              text-caption
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
          >
            <v-container v-if="project">
              <v-row class="text-center">
                <v-col>
                  <span class="font-weight-bold black--text">
                    {{ project.projectName }} ({{ project.metagenomicId }})
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card elevation="2" class="rounded-lg">
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12">
                            <h3 class="text-subtitle-1 primary--text">
                              {{ translations.generalInformation }}
                            </h3>
                          </v-col>
                          <v-col cols="12" md="6">
                            <span class="font-weight-bold">
                              {{ translations.projectType }}:
                            </span>
                            <span v-if="project.type && project.type != ''">
                              {{ getProjectType(project.type) }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                          <v-col cols="12" md="6">
                            <span class="font-weight-bold"> País: </span>
                            <span v-if="project.city && project.city != ''">
                              {{ project.city }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                          <v-col cols="12" md="6">
                            <span class="font-weight-bold">
                              {{ translations.responsible }}:
                            </span>
                            <span
                              v-if="
                                project.assignedTo && project.assignedTo != ''
                              "
                            >
                              {{ project.assignedTo }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                          <v-col cols="12" md="6">
                            <span class="font-weight-bold">
                              {{ translations.label_description }}:
                            </span>
                            <span v-if="project.description">
                              {{ project.description }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                          <v-col cols="12">
                            <span class="font-weight-bold primary--text">
                              {{ translations.label_status }}:
                            </span>
                            <span>{{ getStatus(project.status) }}</span>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card elevation="2" class="rounded-lg">
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12">
                            <h3 class="text-subtitle-1 primary--text">
                              {{ translations.agriculturalDetails }}
                            </h3>
                          </v-col>
                          <v-col cols="12" md="6">
                            <span class="font-weight-bold">
                              {{ translations.targetCrops }}:
                            </span>
                            <div
                              v-if="project.crops && project.crops.length > 0"
                            >
                              <v-row no-gutters>
                                <v-col
                                  cols="auto"
                                  v-for="(crop, index) in project.crops"
                                  :key="index"
                                >
                                  <v-chip size="small" color="primary">
                                    <v-icon>
                                      mdi-sprout
                                    </v-icon>
                                    <span class="white--text"
                                      >{{ getCrop(crop) }}
                                    </span>
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </div>
                            <div v-else>
                              <v-chip
                                size="small"
                                prepend-icon="mdi-sprout"
                                color="grey"
                              >
                                <span> {{ translations.noCrop }} </span>
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="text-start">
                            <span class="font-weight-bold">
                              {{ translations.additionalDetails }}:
                            </span>
                            <v-btn text @click="handleUpdateDescription()">
                              <v-icon color="primary">
                                mdi-pencil
                              </v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <span v-if="project.farmDescription">
                              {{ project.farmDescription }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card elevation="2" class="rounded-lg">
                    <v-card-text>
                      <v-container fluid>
                        <v-row class="text-center">
                          <v-col cols="12">
                            <h3 class="text-subtitle-1 primary--text">
                              {{ translations.importantDates }}
                            </h3>
                          </v-col>
                          <v-col>
                            <span class="font-weight-bold">
                              {{ translations.commercialStartDate }}:
                            </span>
                            <span v-if="project.commercialLaunchDate">
                              {{ getFormatted(project.commercialLaunchDate) }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                          <v-col>
                            <span class="font-weight-bold">
                              {{ translations.projectEndDate }}:
                            </span>
                            <span v-if="project.projectEndDate">
                              {{ getFormatted(project.projectEndDate) }}
                            </span>
                            <span v-else>
                              {{ translations.notSpecified }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <!-- <v-row v-if="project.projectType == 'PRODUCT_SETUP'">
                <v-col class="primary--text font-weight-bold">
                  <span>{{ translations.label_product }}</span>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(product, index) in project.products"
                    :key="index"
                  >
                    <v-chip class="ma-1">
                      <v-icon color="primary">mdi-sprout</v-icon>
                      {{ product.name }} - {{ product.doses }} -
                      {{ getProductType(product.type) }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="project.projectType == 'PRODUCT_SETUP'">
                <v-col class="primary--text font-weight-bold" xl="2">
                  <span>{{ translations.label_applications }}</span>
                </v-col>
                <v-col
                  class="text-end"
                  xl="1"
                  v-if="project.status != 'FINISHED'"
                >
                  <v-btn color="primary" small @click="openModalApplication">
                    <v-icon>mdi-plus</v-icon>
                    {{ translations.label_add_application }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="project.projectType == 'PRODUCT_SETUP'">
                <v-col>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr
                          v-for="(item, index) in project.applications"
                          :key="index"
                        >
                          <td>{{ item.name }}</td>
                          <td>
                            {{ item.doses }} {{ getProductType(item.type) }}
                          </td>
                          <td>{{ item.applicationDate }}</td>
                          <td v-if="project.status != 'FINISHED'">
                            <v-icon @click="removeApplication(item.uuid)"
                              >mdi-close</v-icon
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row> -->
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <NewApplicationModal
      v-if="showNewApplicationModal"
      v-model="showNewApplicationModal"
      @addApplication="updateApplications"
    />
    <v-dialog
      v-model="dialog"
      :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
      persistent
      v-if="project"
    >
      <v-card class="rounded-xl" color="#ffffffD9">
        <v-card-title>
          <span
            class="
                primary--text
                text-subtitle-2
                text-sm-subtitle-1
                text-md-h6
              "
          >
            {{ translations.additionalDetails }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="farmDescription"
            outlined
            :label="translations.label_description"
            rows="4"
            auto-grow
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-container fluid>
            <v-row>
              <v-col>
                <v-btn
                  color="primary"
                  block
                  @click="dialog = false"
                  class="
                mb-5
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
                >
                  {{ translations.cancel }}
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  block
                  @click="saveDescription"
                  class="
                mb-5
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
                >
                  <v-icon left>mdi-content-save</v-icon>
                  {{ translations.save }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
//VUEX
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
//COMPONENTS
import CropZoneItem from "@/components/territory/CropZoneItem.vue";
import NewApplicationModal from "@/components/projects/modals/NewApplicationModal.vue";
export default {
  components: {
    CropZoneItem,
    NewApplicationModal,
  },
  data: () => ({
    panel1: [0],
    panel2: [0],
    project: null,
    version: null,
    versions: [],
    dataVersion: null,
    currentVersion: null,
    schdule: [],
    showNewApplicationModal: false,
    description: null,
    dialog: false,
    farmDescription: null,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["crops"]),
  },
  async mounted() {
    await this.init();
  },
  methods: {
    ...mapMutations("project", ["SET_PRODUCTS", "SET_PROJECT_TO_UPDATED"]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("project", [
      "getById",
      "removeApplicationInProject",
      "addFarmDescription",
    ]),
    async init() {
      this.SET_APPBAR_OPTIONS({
        leftButton: "back-arrow",
        funcLeftButton: this.goBack,
      });
      await this.getProject();
    },
    handleUpdateDescription() {
      this.farmDescription = this.project.farmDescription || "";
      this.dialog = true;
    },
    async getProject() {
      try {
        let payload = {
          projectId: this.$route.params.projectId,
        };
        let response = await this.getById(payload);
        if (!response || response.error) throw response;
        this.project = response.project;
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    async saveDescription() {
      try {
        let payload = {
          farmDescription: this.farmDescription,
        };
        let params = {
          projectId: this.$route.params.projectId,
        };
        let response = await this.addFarmDescription({ params, payload });
        if (!response || response.error) throw response;
        this.project = response.project;
        this.dialog = false;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: this.translations.descriptionSaved,
          timeout: 4000,
        });
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    goBack() {
      this.$router.back();
    },
    getFormatted(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getStatus(value) {
      return this.translations.status_projects[value];
    },
    getCrop(value) {
      return this.translations.crop_name_list[value] || value;
    },
    truncateString(str, num) {
      // If the length of str is less than or equal to num
      // just return str--don't truncate it.
      if (str.length <= num) {
        return str;
      }
      // Return str truncated with '...' concatenated to the end of str.
      return str.slice(0, num) + "...";
    },
    getProjectType(value) {
      let status = {
        MISS_TEST: "Miss test",
        MISS_SETUP: "Product setup",
        MISS_DISCOVERY: "Miss discovery",
        MISS_PRS: "Regenerative Soil Program (RSP)",
        MISS_CROP_SETUP: "Crop setup",
      };

      return status[value] || value;
    },
    getPhenoStage(value) {
      return this.translations.phenologicalStages[value] || value;
    },
    getProductType(value) {
      if (value == "LIQUID") {
        return "L/Ha";
      } else {
        return "Kg/Ha";
      }
    },
    openModalApplication() {
      this.SET_PRODUCTS(this.project.products);
      this.SET_PROJECT_TO_UPDATED(this.project);
      this.showNewApplicationModal = true;
    },
    async removeApplication(uuidToRemove) {
      try {
        let payload = {
          projectId: this.project._id,
          uuidToRemove: uuidToRemove,
        };
        let response = await this.removeApplicationInProject(payload);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: this.translations.label_application_removed,
          timeout: 4000,
        });
        this.project.applications = response.project.applications;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    updateApplications(application) {
      this.SET_PRODUCTS([]);
      this.SET_PROJECT_TO_UPDATED(null);
      this.showNewApplicationModal = false;
      this.project.applications.push(application);
    },
  },
  watch: {},
};
</script>
